import { render, staticRenderFns } from "./OmniaTimeSelect.vue?vue&type=template&id=1908e14d&"
import script from "./OmniaTimeSelect.vue?vue&type=script&lang=js&"
export * from "./OmniaTimeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports